import { io } from "socket.io-client";
import { config } from "../config";

/**
 * Socket.IO client configuration with CORS support for white label domains
 */
export const getSocketOptions = () => ({
  withCredentials: true,
  transports: ['websocket', 'polling'],
  // The browser automatically sends the correct Origin header
  // Our backend CORS configuration handles white label domains
});

/**
 * Create a Socket.IO client instance with proper configuration
 */
export const createSocket = (options = {}) => {
  const socketOptions = {
    ...getSocketOptions(),
    ...options
  };
  
  return io(config.API_URI, socketOptions);
};

/**
 * Shared socket instance for global use
 */
export const socket = createSocket({ autoConnect: false });

export default socket;
